import { GridFilterInputValue } from '../components/panel/filterPanel/GridFilterInputValue';
import { escapeRegExp } from '../utils/utils';
import { GridFilterInputMultipleValue } from '../components/panel/filterPanel/GridFilterInputMultipleValue';
export const getGridStringOperators = () => [{
  value: 'contains',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterRegex = new RegExp(escapeRegExp(filterItem.value), 'i');
    return _ref => {
      let {
        value
      } = _ref;
      return value != null ? filterRegex.test(value.toString()) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'equals',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const collator = new Intl.Collator(undefined, {
      sensitivity: 'base',
      usage: 'search'
    });
    return _ref2 => {
      let {
        value
      } = _ref2;
      return value != null ? collator.compare(filterItem.value, value.toString()) === 0 : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'startsWith',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterRegex = new RegExp("^".concat(escapeRegExp(filterItem.value), ".*$"), 'i');
    return _ref3 => {
      let {
        value
      } = _ref3;
      return value != null ? filterRegex.test(value.toString()) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'endsWith',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterRegex = new RegExp(".*".concat(escapeRegExp(filterItem.value), "$"), 'i');
    return _ref4 => {
      let {
        value
      } = _ref4;
      return value != null ? filterRegex.test(value.toString()) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'isEmpty',
  getApplyFilterFn: () => {
    return _ref5 => {
      let {
        value
      } = _ref5;
      return value === '' || value == null;
    };
  }
}, {
  value: 'isNotEmpty',
  getApplyFilterFn: () => {
    return _ref6 => {
      let {
        value
      } = _ref6;
      return value !== '' && value != null;
    };
  }
}, {
  value: 'isAnyOf',
  getApplyFilterFn: filterItem => {
    if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) {
      return null;
    }
    const collator = new Intl.Collator(undefined, {
      sensitivity: 'base',
      usage: 'search'
    });
    return _ref7 => {
      let {
        value
      } = _ref7;
      return value != null ? filterItem.value.some(filterValue => {
        return collator.compare(filterValue, value.toString() || '') === 0;
      }) : false;
    };
  },
  InputComponent: GridFilterInputMultipleValue
}];